export default __webpack_public_path__ + "static/media/pg-32.b0f87ba9.jpg";